import Subscriptions                   from 'scripts/defa/subscriptions/collection-subscriptions';
import SubscriptionController          from 'scripts/defa/subscriptions/controller-subscription-controller';
import Subscription                    from 'scripts/defa/subscriptions/model-subscription';
import SubscriptionRouter              from 'scripts/defa/subscriptions/router-subscription-router';
import SubscriptionContainer           from 'scripts/defa/subscriptions/view-subscription-container';
import SubscriptionReplaceChoiceForm   from 'scripts/defa/subscriptions/view-subscription-replace-choice-form.js'
import SubscriptionReplaceFlow         from 'scripts/defa/subscriptions/view-subscription-replace-flow';
import SubscriptionSettingsPanel       from 'scripts/defa/subscriptions/view-subscription-settings-panel';
import SubscriptionTerminateChoiceForm from 'scripts/defa/subscriptions/view-subscription-terminate-choice-form';
import SubscriptionTerminateFlow       from 'scripts/defa/subscriptions/view-subscription-terminate-flow';
import SubscriptionTerminateVerificationForm
									   from 'scripts/defa/subscriptions/view-subscription-terminate-verification-form';
import SubscriptionTransferFlow        from 'scripts/defa/subscriptions/view-subscription-transfer-flow';
import SubscriptionTransferForm        from 'scripts/defa/subscriptions/view-subscription-transfer-form';
import Module                          from 'scripts/module';

const SubscriptionsModule = new Module('SubscriptionsModule',{
	collections: {
		Subscriptions
	},
	controllers: {
		SubscriptionController
	},
	models     : {
		Subscription
	},
	routers    : {
		SubscriptionRouter
	},
	views      : {
		SubscriptionContainer,
		SubscriptionReplaceChoiceForm,
		SubscriptionReplaceFlow,
		SubscriptionSettingsPanel,
		SubscriptionTerminateChoiceForm,
		SubscriptionTerminateFlow,
		SubscriptionTerminateVerificationForm,
		SubscriptionTransferFlow,
		SubscriptionTransferForm
	}
});
export default SubscriptionsModule;